var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFixed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 953.519,
    height: 192.546,
    viewBox: "0 0 953.51944 192.54582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2b85df",
    d: "M111.166 192.546L67.45 116.827l23.716-41.14-47.485-.028L0 0h222.333z",
    "data-name": "Exclusion 13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d2e99",
    d: "M222.333 0l43.716 75.719-23.715 41.14 47.483.028 43.682 75.658H111.166z",
    "data-name": "Exclusion 14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFixed);
export default __webpack_public_path__ + "static/media/logo-fixed.9997c587d31c9e9f7d963049fb3d0243.svg";
export { ForwardRef as ReactComponent };